import { createAction } from '@ngrx/store';

export const noopAction = createAction('[App] noop');
